/**
 * 商品
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/28      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import dayjs from 'dayjs';
import {Checkbox} from 'antd';
import LazyLoad from 'react-lazy-load';
import {symbolMoneyUtil} from '@utils/utils';
import "./index.less";
import { loadImage } from "@utils/image-func";
const Locale = require("../../../../../../utils/locale").default;
const locale = Locale.current();
const config = require("@config/config");


class Item extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        const {item = {},currencySymbol=''} = this.props;
        const address = config.essaone[locale];
        return (
            <div className="recommend-goods__item-wrap">
                <div className="item">
                    <div className="img__wrap">
                        <Checkbox value={item.id}></Checkbox>
                        {
                            item.discountPercentage?
                                <img className="discount-tag"
                                     src="https://oss.essaone.com/6b0f316c-b85f-4125-8d9f-626d7c44fae7.png" alt=""/>:null
                        }
                        <LazyLoad height={258}
                                  offset={0}>
                            <img src={loadImage(item.picUrl,200)} alt=""/>
                        </LazyLoad>
                    </div>
                    <div className="content__wrap">
                        <div className="flex-box align-items-center flex-item-between">
                            <b className="font_18 color089">{symbolMoneyUtil(item.salePrice,currencySymbol)}</b>
                            <span className="label">{item.firstToMarketTime?dayjs(item.firstToMarketTime).format('YYYY-MM-DD'):'-'}</span>
                        </div>
                        <div className="color066 font_14 flex-box align-items-center">
                            <span className="flex-box align-items-center">
                                <img className="mr_4" src="http://oss.essa.cn/6c0a10eb-7ebf-4cf3-b347-009c9dd6069c.svg"/>
                                <span>{item.purchaseMoq||'-'} {__getServerLanguage('WaiXiang')}</span>
                            </span>
                            <span className="flex-box align-items-center ml_16">
                                <i className="ri-time-line font_16 mr_4"></i>
                                <span>{item.deliverDay||'-'} {__getServerLanguage('Tian')}</span>
                            </span>
                        </div>
                        <a className="name mt_8" title={item.name} onClick={(e)=>{
                            e.stopPropagation();
                            e.preventDefault();
                            window.open(`${address}/${item.id}.html?skuNo=${item.no}`);
                        }}>{item.name||'-'}</a>
                        <div className="flex-box align-items-center flex-item-between font_12 color066">
                            <span>{__getServerLanguage('ShangPin')} {item.no||'-'}</span>
                            <span className="supplier-name" title={item.supplierName||'-'}>{item.supplierName||'-'}</span>
                        </div>
                        <a className="btn-join" onClick={(e)=>{
                            e.stopPropagation();
                            e.preventDefault();
                            this.props.addCart(item);
                        }}>{__getServerLanguage('JiaRuTuiJian')}</a>
                    </div>
                </div>
            </div>
        )
    }
}

Item.defaultProps = {
}

Item.propTypes = {

}
export default Item;
